const productNutrition = (() => {
  const EL_NAV = '[data-nutritional-nav]';
  const EL_TAB = '[data-nutritional-tab]';
  const EL_TOGGLE = '[data-nutrition-toggle]';
  const EL_MODAL = '[data-nutrition-modal]';
  
  const url = new URL(window.location);

  function toggleTab(ev) {
    ev.preventDefault();
    const elNav = ev.currentTarget;
    const elNavs = elNav.parentNode.querySelectorAll(EL_NAV);
    
    elNavs.forEach(el => {
      const controls = el.getAttribute('aria-controls');
      const elTab = el.parentNode.parentNode.querySelector(`${EL_TAB}[id="${controls}"]`);
      let isActive = el == elNav;

      el.classList.toggle('active', isActive);
      elTab.classList.toggle('active', isActive);
    })
  }

  function toggleModal(ev) {
    ev.preventDefault();
    const elToggle = ev.currentTarget;
    const id = elToggle.getAttribute('data-nutrition-toggle');
    const elModal = document.querySelector(`[data-nutrition-modal="${id}"]`);
    const { param } = elModal.dataset;

    if(elModal) {
      let isOpen = elModal.getAttribute('aria-hidden') == 'false';
      if(isOpen) {
        document.body.classList.remove('overflow-hidden');
        elModal.setAttribute('aria-hidden', true);
        url.hash = '';
        setTimeout(() => {
          elModal.classList.remove('active');
        }, 300)
      } else {
        document.body.classList.add('overflow-hidden');
        elModal.classList.add('active');
        url.hash = param;
        setTimeout(() => {
          elModal.setAttribute('aria-hidden', false);
        }, 100)
      }
      window.history.replaceState({}, "", url);
    }
  }

  function openModalonLoad() {
    const elModal = document.querySelector(EL_MODAL);
    const { param } = elModal.dataset;

    if(url.hash == `#${param}`) {
      document.body.classList.add('overflow-hidden');
      elModal.classList.add('active');
      setTimeout(() => {
        elModal.setAttribute('aria-hidden', false);
      }, 100)
    }
  }

  function init() {
    const elNav = document.querySelectorAll(EL_NAV);
    elNav.forEach(el => {
      el.removeEventListener('click', toggleTab);
      el.addEventListener('click', toggleTab);
    })

    const elToggles = document.querySelectorAll(EL_TOGGLE);
    elToggles.forEach(el => {
      el.removeEventListener('click', toggleModal);
      el.addEventListener('click', toggleModal);
    })

    openModalonLoad();
  }

  return {
    init
  }

})();

document.addEventListener('DOMContentLoaded', () => {
  productNutrition.init();
})